import React from "react";
import { connect } from "react-redux";
import { closeModal } from "actions/modals";
import PropTypes from "prop-types";

import Modal, { ModalBody, ModalHeader } from "components/Modal";
import Translate from "utils/translate";

import styles from "./FloorplanInfoModal.css";

const { t } = new Translate("Floorplans");

const FloorplanInfoModal = ({ onCloseInfoModal }) => (
  <Modal className={styles.root} onClose={onCloseInfoModal} isOpen>
    <ModalHeader onClose={onCloseInfoModal}>{t("informationTitle")}</ModalHeader>
    <ModalBody>
      <div className={styles.root} dangerouslySetInnerHTML={{ __html: t("information") }} />
    </ModalBody>
  </Modal>
);

FloorplanInfoModal.propTypes = {
  onCloseInfoModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  onCloseInfoModal: () => dispatch(closeModal("FloorplanInfoModal")),
});

export default connect(null, mapDispatchToProps)(FloorplanInfoModal);
